import { epicRequest, reducersMerge, reduxCreator, reduxFetchCreator, serverResponse } from 'app'

import type { TeamSchema } from 'teams'

export type VerificationsFilter = {
  create: boolean
  include: boolean
  teams: string
  tournamentId: string
}

const getInitialState = () =>
  serverResponse<{ excluded: boolean; included: boolean; name: string; team: null | TeamSchema }[]>({
    data: [],
  })

const verifications = reduxFetchCreator<'teamsVerifications', VerificationsFilter, ReturnType<typeof getInitialState>>(
  'teamsVerifications',
  getInitialState(),
)

const teamsVerificationsEpic = epicRequest({
  actionType: verifications.actions.teamsVerifications.type,
  debounce: 700,
  // @todo fix type
  errorAction: verifications.actions.teamsVerificationsError,
  fulfilledAction: verifications.actions.teamsVerificationsFulfilled,
  request: (action: { payload: VerificationsFilter }) => ({
    body: action.payload,
    method: 'post',
    url: `sports/tournament/${action.payload.tournamentId}/checkTeams`,
  }),
  // @ts-ignore
  untilTypes: verifications.actions.teamsVerificationsCancel.type,
})

const clear = reduxCreator<'teamsVerificationsClear', undefined, ReturnType<typeof getInitialState>>(
  'teamsVerificationsClear',
  getInitialState(),
  () => getInitialState(),
)

export const actions = {
  ...verifications.actions,
  teamsVerificationsClear: clear.teamsVerificationsClear,
}

export const epics = [teamsVerificationsEpic]

export const reducer = reducersMerge(clear.reducer, verifications.reducer) as typeof verifications.reducer
